<template>
  <v-dialog v-model="dialogVisible" fullscreen persistent>
    <v-card>
      <v-toolbar color="primary" dark>
        <v-btn icon @click="fecharDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ titulo }}</v-toolbar-title>
        <v-spacer></v-spacer>
        
        <!-- Controles de visualização da imagem -->
        <v-btn icon @click="zoomIn">
          <v-icon>mdi-magnify-plus-outline</v-icon>
        </v-btn>
        <v-btn icon @click="zoomOut">
          <v-icon>mdi-magnify-minus-outline</v-icon>
        </v-btn>
        <v-btn icon @click="rotateClockwise">
          <v-icon>mdi-rotate-right</v-icon>
        </v-btn>
        <v-btn icon @click="rotateCounterClockwise">
          <v-icon>mdi-rotate-left</v-icon>
        </v-btn>
        <v-btn icon @click="resetView">
          <v-icon>mdi-restore</v-icon>
        </v-btn>
        
        <!-- Botão para abrir em nova aba -->
        <v-btn icon :href="imagemUrl" target="_blank">
          <v-icon>mdi-open-in-new</v-icon>
        </v-btn>
        
        <!-- Botão para download da imagem -->
        <v-btn icon :href="imagemUrl" download>
          <v-icon>mdi-download</v-icon>
        </v-btn>
      </v-toolbar>
      
      <v-card-text class="pa-0 fill-height">
        <!-- Container para a imagem com altura total -->
        <div class="imagem-container">
          <img 
            v-if="imagemUrl" 
            :src="imagemUrl" 
            class="imagem-viewer" 
            :style="imagemViewerStyle"
            @error="onImageError"
          />
          <div v-if="erro" class="erro-container">
            <v-icon size="80" color="error">mdi-image-off</v-icon>
            <p class="text-h6 mt-4">Erro ao carregar a imagem</p>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'VisualizarImagem',
  
  props: {
    // Controla a visibilidade do diálogo
    modelValue: {
      type: Boolean,
      default: false
    },
    
    // URL da imagem a ser exibida
    imagemUrl: {
      type: String,
      required: true
    },
    
    // Título a ser exibido na barra superior
    titulo: {
      type: String,
      default: 'Visualizador de Imagem'
    }
  },
  
  data() {
    return {
      // Variáveis para controle de zoom e rotação
      zoom: 1,
      rotation: 0,
      erro: false
    };
  },
  
  computed: {
    // Controle de visibilidade do diálogo com v-model
    dialogVisible: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    },
    
    // Estilo para o visualizador de imagem com zoom e rotação
    imagemViewerStyle() {
      return {
        transform: `scale(${this.zoom}) rotate(${this.rotation}deg)`,
        transformOrigin: 'center center',
        transition: 'transform 0.3s ease'
      };
    }
  },
  
  methods: {
    // Fecha o diálogo
    fecharDialog() {
      this.dialogVisible = false;
      this.resetView();
      this.erro = false;
    },
    
    // Aumenta o zoom
    zoomIn() {
      this.zoom = Math.min(this.zoom + 0.2, 5); // Limite máximo de zoom: 5x
    },
    
    // Diminui o zoom
    zoomOut() {
      this.zoom = Math.max(this.zoom - 0.2, 0.3); // Limite mínimo de zoom: 0.3x
    },
    
    // Rotaciona no sentido horário
    rotateClockwise() {
      this.rotation = (this.rotation + 90) % 360;
    },
    
    // Rotaciona no sentido anti-horário
    rotateCounterClockwise() {
      this.rotation = (this.rotation - 90 + 360) % 360;
    },
    
    // Reinicia a visualização
    resetView() {
      this.zoom = 1;
      this.rotation = 0;
    },
    
    // Trata erro ao carregar imagem
    onImageError() {
      this.erro = true;
    }
  },
  
  // Reinicia o zoom e rotação quando o componente é montado
  mounted() {
    this.resetView();
  },
  
  // Reseta erro quando a URL mudar
  watch: {
    imagemUrl() {
      this.erro = false;
    }
  }
};
</script>

<style scoped>
/* Estilos para o visualizador de imagem */
.imagem-container {
  width: 100%;
  height: calc(100vh - 64px); /* Altura total menos a altura da toolbar */
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #303030;
  padding: 20px;
}

.imagem-viewer {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  background-color: white;
}

.erro-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
}
</style>
